import { Component, OnInit } from '@angular/core';
import {FormBuilder} from "@angular/forms";
import {DynamicScriptLoaderServiceService} from "../../_services/dynamic-script-loader-service.service";
import {AuthenicationService} from "../../_services/authenication.service";
import {ActivatedRoute, Router} from "@angular/router";
import {PatientsService} from "../../_services/patients.service";
import {ToasterService} from "../../_services/toaster.service";
import {UserService} from "../../_services/user.service";

declare var $: any;
@Component({
  selector: 'app-usertestlist',
  templateUrl: './usertestlist.component.html',
  styleUrls: ['./usertestlist.component.css']
})
export class UsertestlistComponent implements OnInit {

  userdetaild: string;
  returnUrl: string;
  testlist: [];

  id: string = this.route.snapshot.params['id'];

  constructor(private formBuilder: FormBuilder, private dynamicScriptLoader: DynamicScriptLoaderServiceService, private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private patientsService: PatientsService, private toaster: ToasterService, private userservice: UserService) { }

  ngOnInit() {

    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }


    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';


    this.userTestList(this.id);
  }

  userTestList(id) {
    this.userservice.getUserTestList(id)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
             //this.toaster.showSuccess('MindPeers', data.ResponseMessage);
            this.testlist = data.testData;
            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          } else {
            this.toaster.showError('MindPeers', data.ResponseMessage);
            setTimeout( () => {
              $(function () {
                $('#example').DataTable();
              });
            }, 1000);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('MindPeers', error.error.ResponseMessage);
          setTimeout( () => {
            $(function () {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }
}
